document.addEventListener('DOMContentLoaded', function () {
  const range = document.getElementById('tensao-range');
  const bubble = document.getElementById('range-bubble');
  const mensagem = document.getElementById('tensao-mensagem');
 
  const mensagens = [
    { min: 40, max: 45, msg: 'Mais potência, menos controle. Ideal para iniciantes.' },
    { min: 46, max: 52, msg: 'Equilíbrio entre potência e controle.' },
    { min: 53, max: 56, msg: 'Mais controle com leve perda de potência.' },
    { min: 57, max: 60, msg: 'Máximo controle, indicada para jogadores avançados.' }
  ];

function updateRangeDisplay() {
  const val = parseInt(range.value, 10);
  const min = parseInt(range.min);
  const max = parseInt(range.max);
  const percent = ((val - min) / (max - min)) * 100;

  bubble.innerText = `${val}Lbs`;

  // Ajustes especiais nas pontas
  if (percent <= 0) {
    bubble.style.left = '-2%';
    bubble.style.setProperty('--arrow-left', '31%');
    bubble.style.setProperty('--bubble-shift', '0%');
  } else if (percent >= 100) {
    bubble.style.left = `calc(${percent}% - 57px)`;
    bubble.style.setProperty('--arrow-left', '74%');
    bubble.style.setProperty('--bubble-shift', '0%');
  } else {
    bubble.style.left = `calc(${percent}% + 0px)`;
    bubble.style.setProperty('--arrow-left', '53%');
    bubble.style.setProperty('--bubble-shift', '-53%');
  }

  range.style.background = `linear-gradient(to right, #4B2A74 ${percent}%, #eee ${percent}%)`;

  for (const item of mensagens) {
    if (val >= item.min && val <= item.max) {
      mensagem.innerText = item.msg;
      break;
    }
  }
}

  if (range && bubble && mensagem) {
    updateRangeDisplay();
    range.addEventListener('input', updateRangeDisplay);
  }


  // Lista de URLs ou parte delas para abrir em nova aba
  const externalLinks = [
    'https://instagram.com',
    'https://wa.me',
    'https://api.whatsapp.com',
    'https://facebook.com',
  ];

  // Seleciona todos os links do menu
  document.querySelectorAll('nav a, .site-nav a, .menu a, .footer-block__list a').forEach(link => {
    if (externalLinks.some(url => link.href.includes(url))) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });

  
});